import { MutationTree } from "vuex";
import { FirestoreState, SET_DOCUMENT_ID, SET_DOCUMENT_DATA } from "./types";
import { firebase, db } from "#/mixins/firebase";

export const mutations: MutationTree<FirestoreState> = {
  [SET_DOCUMENT_ID](state, documentId: string) {
    if (state.documentId === documentId) {
      //ドキュメントIDが同じであれば、何もしない
      return;
    }
    state.firebaseData = db.collection(state.collection).doc(documentId);
    state.documentId = documentId;
  },
  [SET_DOCUMENT_DATA](state, data?: firebase.firestore.DocumentData) {
    state.data = data;
  }
};
